import "./HeatPumps.module.css";
import Header from "@/reusable_sections/Header";
import HeatPumpInstallationDublin from "./sections/HeatPumpInstallationDublin";
import SeaiGrantInformation from "./sections/SeaiGrantInformation";
import FreeHeatPumpAssessment from "./sections/FreeHeatPumpAssessment";
import Footer from "@/reusable_sections/Footer";
export default function HeatPumpsPage() {
  return <div>
      <Header />
      <HeatPumpInstallationDublin />
      <SeaiGrantInformation />
      <FreeHeatPumpAssessment />
      <Footer />
    </div>;
}